import React from "react";

import { useTranslation } from "react-i18next";

import Header from "../../contruction-home/components/Header";
import Footer from "../../contruction-home/components/Footer";
import Hero from "../../contruction-home/components/Hero";
import NormalUserLayout from "../../layouts/NormalUserLayout/NormalUserLayout";

import {
  FaMountainCity,
  FaArrowUpFromGroundWater,
  FaCompassDrafting,
  FaTrowelBricks,
  FaHelmetSafety
} from "react-icons/fa6";
import { BiCheckShield } from "react-icons/bi";
import { BsArrowRight, BsBrightnessAltHigh, BsFileEasel } from "react-icons/bs";
import mainImg from "../assets/img/alt-services.jpg";

const Partner = () => {
  const { t } = useTranslation();

  const services = [
    {
      id: 1,
      icon: <FaMountainCity />,
      description: t("partner.items.1.description"),
      delay: 100
    },
    {
      id: 2,
      icon: <FaArrowUpFromGroundWater />,
      description: t("partner.items.2.description"),
      delay: 200
    },
    {
      id: 3,
      icon: <FaCompassDrafting />,
      description: t("partner.items.3.description"),
      delay: 300
    },
    {
      id: 4,
      icon: <FaTrowelBricks />,
      description: t("partner.items.4.description"),
      delay: 400
    },
    {
      id: 5,
      icon: <FaHelmetSafety />,
      description: t("partner.items.5.description"),
      delay: 500
    }
  ];

  const iconBoxes = [
    {
      id: 1,
      icon: <BsFileEasel className="flex-shrink-0" />,
      link: "#",
      description: t("partner.alt.boxes.1.description"),
      delay: 300
    },
    {
      id: 2,
      icon: <BiCheckShield className="flex-shrink-0" />,
      link: "#",
      description: t("partner.alt.boxes.2.description"),
      delay: 400
    },
    {
      id: 3,
      icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
      link: "#",
      description: t("partner.alt.boxes.3.description"),
      delay: 500
    },
    {
      id: 4,
      icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
      link: "#",
      description: t("partner.alt.boxes.4.description"),
      delay: 600
    },
    {
      id: 5,
      icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
      link: "#",
      description: t("partner.alt.boxes.4.description"),
      delay: 600
    }
  ];

  return (
    <div className="ConstructionHome">
      <NormalUserLayout>
        <Header />
        <main className="main">
          {/* <div style={{ background: "rgba(0, 0, 0, 1)" }}> */}
          <Hero compact />
          <section id="services" className="services section light-background">
            {/* Section Title */}
            <div className="container section-title" data-aos="fade-up">
              <h2>{t("partner.title")}</h2>
              <p>{t("partner.subtitle")}</p>
            </div>

            <div className="container">
              <div className="row gy-4">
                {services.map(({ id, icon, title, description, delay }) => (
                  <div
                    key={id}
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-delay={delay}
                  >
                    <div className="service-item position-relative">
                      <div className="icon">{icon}</div>
                      <p>{description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </NormalUserLayout>
    </div>
  );
};

export default Partner;
